export const enum RoundTablePropertiesEnum {
  SelectionType = "selectionType",
  Category = "category",
  SeatsQuantity = "seatsQuantity",
  EmptySpacesQuantity = "emptySpacesQuantity",
  Radius = "radius",
  SectionLabel = "sectionLabel",
  TableLabelingVisible = "tableLabelingVisible",
  TableLabelingLabel = "tableLabelingÑabel",
  TableLabelingDisplayedLabel = "tableLabelingDisplayedLabel",
  SeatLabelingType = "seatLabelingType",
  SeatLabelingStartsAt = "seatLabelingStartsAt"
}